export default {
  '创建时间': '创建时间',
  '操作': '操作',
  '更多': '更多',
  '查询': '查询',
  '重置': '重置',
  '新增': '新增',
  '编辑': '编辑',
  '详情': '详情',
  '删除': '删除',
  '批量删除': '批量删除',
  '类型': '类型',
  '类型名称': '类型名称',
  '类型图片': '类型图片',
  '压力': '压力',
  '位移': '位移',
  '温度': '温度',
  '设备名称': '设备名称',
  '设备编号': '设备编号',
  '是否报警': '是否报警',
  '用户登录号': '用户登录号',
  '用户昵称': '用户昵称',
  '总报警次数': '总报警次数',
  '今日报警次数': '今日报警次数',
  '采集值': '采集值',
  '单位': '单位',
  '用户': '用户',
  '设备类型': '设备类型',
  '报警阀值': '报警阀值',
  '报警阀值上偏差': '报警阀值上偏差',
  '报警阀值下偏差': '报警阀值下偏差',
  '设备地址': '设备地址',
  '看板': '看板',
  '历史数据': '历史数据',
  '报警数据': '报警数据',
  '信息概括': '信息概括',
  '历史统计图': '历史统计图',
  '报警统计图': '报警统计图',
  '开始时间': '开始时间',
  '结束时间': '结束时间',
  '日期范围': '日期范围',
  '采集类型': '采集类型',
  '报警类型': '报警类型',
  '低报': '低报',
  '高报': '高报',
  '昵称': '昵称',
  '物流中心名称': '物流中心名称',
  '状态': '状态',
  '禁用': '禁用',
  '启用': '启用',
  '头像': '头像',
  '物流管理员名称': '物流管理员名称',
  '物流管理员手机号': '物流管理员手机号',
  '重置密码': '重置密码',
  '密码': '密码',
  '性别': '性别',
  '物流中心': '物流中心',
  '用户名': '用户名',
  '手机号': '手机号',
  '物流公司': '物流公司',
  '用户账号': '用户账号',
  '反馈类型': '反馈类型',
  '反馈内容': '反馈内容',
  '反馈图片': '反馈图片',
  '回复内容': '回复内容',
  '处理': '处理',
  '总数': '总数',
  '处理总数': '处理总数',
  '未处理总数': '未处理总数',
  '待处理': '待处理',
  '已处理': '已处理',
  '产品建议': '产品建议',
  '功能故障': '功能故障',
  '其他问题': '其他问题',
  '简述': '简述',
  '内容': '内容',
  '序号': '序号',
  '登录账号':'登录账号',
  '重置为默认密码':'重置为默认密码',
  '设备列表':'设备列表',
  '请输入':'请输入 ',
  '问题标题':'问题标题',
  '修改':'修改',
  '设备详情':'设备详情',
  '返回':'返回',
  '信息概览':'信息概览',
  '采集':'采集',
  '报警值':'报警值',
  '历史轨迹':'历史轨迹',


  '最后登录时间':'最后登录时间',
  '注册时间':'注册时间',
  '用户总数':'用户总数',
  '禁用用户总数':'禁用用户总数',
  '确定要禁用该用户吗':'确定要禁用该用户吗',
  '请选择商家':'请选择商家',
  '请选择门店':'请选择门店',
  '总门店数':'总门店数',
  '停用店铺数':'停用店铺数',
  '总订单数':'总订单数',
  '今日订单数':'今日订单数',
  '本月订单数':'本月订单数',
  '反馈订单数':'反馈订单数',
  '总收益金额':'总收益金额',
  '今日收益金额':'今日收益金额',
  '本月收益金额':'本月收益金额',
  '总用户数':'总用户数',
  '平台用户数':'平台用户数',
  '总商家数':'总商家数',
  '今日注册':'今日注册',
  '本月注册':'本月注册',
  '反馈设备数':'反馈设备数',
  '总仓库数':'总仓库数',
  '总办公室数':'总办公室数',
  '总会议室数':'总会议室数',
  '总座位数':'总座位数',
  '总继电器数':'总继电器数',
  '总设备数':'总设备数',
  '设备在线数':'设备在线数',
  '设备离线数':'设备离线数',
  '订单数':'订单数',
  '用户曲线':'用户曲线',
  '收益':'收益',
  '设备数':'设备数',
  '问题占比':'问题占比',
  '用户活跃':'用户活跃',
  '用户注册':'用户注册',
  '门店增加':'门店增加',
  '代理商排名':'代理商排名',
  '总收益':'总收益',
  '场地数':'场地数',
  '排名':'排名',
  '商家名称':'商家名称',
  '门店数':'门店数',
  '门店名称':'门店名称',
  '总营收':'总营收',
  '用户编码':'用户编码',
  '注销原因':'注销原因',
  '注销时间':'注销时间',
  '角色':'角色',
  '区号':'区号',
  '门店数量':'门店数量',
  '最后登录IP':'最后登录IP',
  '备注':'备注',
  '登录密码':'登录密码',
  '确认密码':'确认密码',
  '全部':'全部',
  '会议室':'会议室',
  '办公室':'办公室',
  '仓库':'仓库',
  '同步':'同步',
  '批量绑定门店':'批量绑定门店',
  '店铺名称':'店铺名称',
  '商家手机号':'商家手机号',
  '绑定房间编号':'绑定房间编号',
  '设备版本号':'设备版本号',
  '导出':'导出',
  '所属店铺':'所属店铺',
  '所属商家':'所属商家',
  '订单':'订单',
  '日志':'日志',
  '今日销售额':'今日销售额',
  '总销售额':'总销售额',
  '子设备数':'子设备数',
  '设备信息':'设备信息',
  '营业额':'营业额',
  '设备房间类型':'设备房间类型',
  '版本号':'版本号',
  '最近上线时间':'最近上线时间',
  '最近离线时间':'最近离线时间',
  '下载模板':'下载模板',
  '批量绑定商家':'批量绑定商家',
  '设备状态':'设备状态',
  '在线时间':'在线时间',
  '离线时间':'离线时间',
  '名称':'名称',
  '负责人手机号':'负责人手机号',
  '共享座位':'共享座位',
  '共享会议室':'共享会议室',
  '共享办公室':'共享办公室',
  '共享仓库':'共享仓库',
  '主图':'主图',
  '地址':'地址',
  '配置座位':'配置座位',
  '配置会议室':'配置会议室',
  '配置办公室':'配置办公室',
  '配置仓库':'配置仓库',
  '上架':'上架',
  '下架':'下架',
  '座位配置':'座位配置',
  '收费模板':'收费模板',
  '按小时租借':'收费模板',
  '按月租借':'按月租借',
  '座位分布图':'座位分布图',
  '小时费用':'小时费用',
  '月费用':'月费用',
  '按照天租借':'按照天租借',
  '按照年租借':'按照年租借',
  '天费用':'天费用',
  '年费用':'年费用',
  '座位编号':'座位编号',
  '确认':'确认',
  '取消':'取消',
  '使用状态':'使用状态',
  '使用开始时间':'使用开始时间',
  '使用结束时间':'使用结束时间',
  '请选择座位编号':'请选择座位编号',
  '会议室配置':'会议室配置',
  '会议室分布图':'会议室分布图',
  '房间编号':'房间编号',
  '指纹数':'指纹数',
  '座位数':'座位数',
  '房间大小':'房间大小',
  '房间图片':'房间图片',
  '时间类型':'时间类型',
  '订单类型':'订单类型',
  '订单状态':'订单状态',
  '支付状态':'支付状态',
  '订单金额':'订单金额',
  '用户信息':'用户信息',
  '用户头像':'用户头像',
  '订单信息':'订单信息',
  '外部订单号':'外部订单号',
  '支付时间':'支付时间',
  '使用人数':'使用人数',
  '座位数量':'座位数量',
  '支付方式':'支付方式',
  '支付金额':'支付金额',
  '收费规则':'收费规则',
  '模板名称':'模板名称',
  '收费金额':'收费金额',
  '门店信息':'门店信息',
  '联系方式':'联系方式',
  '售后信息':'售后信息',
  '售后反馈':'售后反馈',
  '处理图片':'处理图片',
  '处理结果':'处理结果',
  '小时计费金额':'小时计费金额',
  '天计费金额':'天计费金额',
  '月计费金额':'月计费金额',
  '年计费金额':'年计费金额',
  '回复状态':'回复状态',
  '评论图片':'评论图片',
  '评论内容':'评论内容',
  '评分':'评分',
  '回复用户昵称':'回复用户昵称',
  '回复用户手机号':'回复用户手机号',
  '回复时间':'回复时间',
  '回复':'回复',
  '终端':'终端',
  '升级类型':'升级类型',
  '版本名称':'版本名称',
  '更新类型':'更新类型',
  '计划更新':'计划更新',
  '计划更新时间':'计划更新时间',
  '更新内容':'更新内容',
  '已更新数':'已更新数',
  '用户端':'用户端',
  '商家端':'商家端',
  '整包更新':'整包更新',
  '立即更新':'立即更新',
  '等待升级':'等待升级',
  '下发':'下发',
  '参数名称':'参数名称',
  '参数分组':'参数分组',
  '系统内置':'系统内置',
  '参数键名':'参数键名',
  '参数类型':'参数类型',
  '参数键值':'参数键值',
  '消息类型':'消息类型',
  '消息终端':'消息终端',
  '消息标题':'消息标题',
  '消息简述':'消息简述',
  '消息内容':'消息内容',
  '业务类型':'业务类型',
  '请求方法':'请求方法',
  '请求地址':'请求地址',
  '请求参数':'请求参数',
  '操作类型':'操作类型',
  '操作人员':'操作人员',
  '操作地点':'操作地点',


  '请选择代理商':'请选择代理商',
  '门店排名':'门店排名',
  '保密':'保密',
  '正常':'正常',
  '代理商':'代理商',
  '代理商手机号':'代理商手机号',
  '在线状态':'在线状态',
  '待支付':'待支付',
  '日':'日',
  '已支付':'已支付',
  '小时':'小时',
  '完成':'完成',
  '房间类型':'房间类型',
  '操作人账号':'操作人账号',
  '操作内容':'操作内容',
  '导入':'导入',
  '在线':'在线',
  '离线':'离线',
  '大门':'大门',
  '操作时间':'操作时间',
  '停用':'停用',
  '是':'是',
  '否':'否',
  '是否配置座位':'是否配置座位',
  '是否配置会议室':'是否配置会议室',
  '是否配置办公室':'是否配置办公室',
  '是否配置仓库':'是否配置仓库',
  '店铺信息':'店铺信息',
  '房间配置':'房间配置',
  '最短租借分钟':'最短租借分钟',
  '好评星级':'好评星级',
  '营业时间':'营业时间',
  '详情图':'详情图',
  '按照小时租借':'按照小时租借',
  '按照月租借':'按照月租借',
  '时费用':'时费用',
  '人脸门锁':'人脸门锁',
  '密码门锁':'密码门锁',
  '继电器':'继电器',
  '评论':'评论',
  '用户手机号':'用户手机号',
  '已回复':'已回复',
  '刷新':'刷新',
  '系统消息':'系统消息'




































}
